
export default {
    //API_BASEPATH: 'http://localhost/uat-lms/api/index.php',
    API_BASEPATH: process.env.REACT_APP_API_BASE_URL || 'https://fintech.actoloan.in/api',
    PROFILE_PIC_BASE_URL: process.env.REACT_APP_PROFILE_PIC_BASE_URL || 'https://fintech.actoloan.in/upload/CLIENT_DOCS/',

   loan: {
      SEND_OTP: "/Api/Website/BeginLoanJourneyController/appCustomerRegisteration",
      VERIFY_OTP: "/Api/Website/BeginLoanJourneyController/appCustomerRegisteration",
      GET_DASHBOARD: "/Api/Website/BeginLoanJourneyController/getDashboardData",
      VERIFY_PAN: "/Api/Website/BeginLoanJourneyController/appCustomerRegisteration",
      PERSONAL_DETAILS: "/Api/Website/BeginLoanJourneyController/appCustomerRegisteration",
      INCOME_DETAILS: "/Api/Website/BeginLoanJourneyController/appCustomerRegisteration",
      ADDRESS_DETAILS: "/Api/Website/BeginLoanJourneyController/appCustomerRegisteration",
      CUSTOMER_DOCUMENT: "/Api/Website/BeginLoanJourneyController/saveleadDetails",
      STATE_CITY_PINCODE: "/Api/MasterController/masterAPI",
      UPLOAD_PROFILE_PIC: "/Api/Website/BeginLoanJourneyController/appCustomerRegisteration",
      PROFILE_PIC: "/Api/Website/BeginLoanJourneyController/appCustomerRegisteration",
      CHECK_ELIGIBILITY: "/Api/Website/BeginLoanJourneyController/appCustomerRegisteration",
      ABOUT_COMPANY: "/Api/Website/BeginLoanJourneyController/saveleadDetails",
      CALCULATE_LOAN: "/Api/Website/BeginLoanJourneyController/saveleadDetails",
      USER_DATA: "/Api/Website/getUser",
      ALL_LEADS: "/Api/Website/BeginLoanJourneyController/getLeadList",
      LOAN_DETAIL: "/Api/Website/BeginLoanJourneyController/getLeadDetail",
      GENERATE_LOAN: "/Api/Website/BeginLoanJourneyController/saveleadDetails",
      GENERATE_ORDER_ID: "/Api/Website/BeginLoanJourneyController/generateRazorpayorderId",
      MANDATORY_DOCS: "/Api/Website/BeginLoanJourneyController/check_customer_mandatory_documents",
      CUSTOMER_DETAILS: "/Api/Website/BeginLoanJourneyController/getCustomerDetails",
      EKYC_DIGILOCKER_REQUEST: "/Api/Website/EkycController/digilockerRequest",
      EKYC_DIGILOCKER_STATUS: "/Api/Website/EkycController/digilockerStatus",
      ACCOUNT_AGGREGATOR_REQUEST: "/Api/Website/AccountAggregatorController/consentRequest",
      ACCOUNT_AGGREGATOR_STATUS: "/Api/Website/AccountAggregatorController/consentStatus",
   }
}


{/* <meta name="robots" content="noindex, nofollow" /> */ }